// Entrada del navegador. Igual a la predeterminada de TanStack Start, pero
// antes de hidratar carga y activa el idioma que ya eligió el servidor
// (<html lang>). Sin esto, en conexiones lentas React hidrataba con el
// español por defecto mientras el HTML venía en otro idioma (error #418).
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { StartClient } from "@tanstack/react-start/client";
import { setLanguage } from "@/i18n";

async function boot() {
  try {
    await setLanguage(document.documentElement.lang || "es");
  } catch {
    /* no bloquear la hidratación */
  }
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <StartClient />
      </StrictMode>,
    );
  });
}

void boot();
